module.exports = __webpack_public_path__ + "img/reivernetLogo.2648e6d7.jpg";